import "./src/index.js"
import "./src/test.js"